import script from "./PublishModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PublishModal.vue?vue&type=script&setup=true&lang=js"

import "./PublishModal.vue?vue&type=style&index=0&id=2cdff28a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cdff28a"]])

export default __exports__